import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import LazyLoad from 'vanilla-lazyload';

import 'jquery-hoverintent';
import 'scrolltofixed';
import 'slick-carousel';

import OneDrawer from '@/modules/module-oneDrawer';
import OneSubscribe from '@/modules/module-oneSubscribe';
import OneCookieBanner from '@/modules/module-oneCookieBanner';
import OneMobileMenu from '@/modules/module-oneMobileMenu';
import OneVideo from '@/modules/module-oneVideo';

export default Backbone.View.extend({
    
    initialize: function (opts) {
        
        console.log('init global');
        
        // Testing $ object
        // console.log($.fn.jquery);
        
        var self = this;
        self.$body = self.$el;
        self.$header = $('header.site-header');
        self.$footer = $('footer.site-footer');
        self.$miniCart = $('#MiniCart');
        self.$mobileNav = $('#MobileNav');
        self.$searchBar = $('#SearchBar');
        self.$promoBanner = self.$header.find('.promo-banner');
        self.$navi = self.$header.find('nav');
        self.$menuToggle = self.$header.find('.menu-toggle');
        
        self.searchInlineMode = false; // Set false to use search modal, set true to use inline search mode. 
        self.miniCartAsDropdown = false; // Set false to use drawer, set true to use dropdown on Desktop (drawer on Mobile).
        self.useSlideInMenuForLevel2 = false; // Set false to use accordion for all nav levels on Mobile, set true to use the slide-in-menu for level 2.
        
        self.initLazyImages();
        self.initPromoBanner();
        self.initCookieBanner();
        self.initFixedHeader();
        self.initNavi();
        self.initUtilities();
        self.initSearch();
        self.initMiniCart();
        self.initMobileMenu();
        self.initSubscirbe();
        self.initFooter();
        self.devTools();

        if (self.$body.find(".multisection-module")) {
            self.multisection();
        }
    },

    events: {
        'drawer-opt' : 'bodyClassCtl',
        'menu-opt-in' : 'bodyClassCtl',
        'menu-opt-out' : 'bodyClassCtl',
        'click .account-nav .select-link': function (e) {
            $('.account-nav .links').toggleClass('opened');
        },
        'change #notes-toggle': function (e) {
            const content = document.querySelector('.toggle-content');
            content.classList.toggle('show');
        }
    },
    
    bodyClassCtl : function(e, showOverlay = true){
        // Please prevent operation on more then one drawer at the same time
        var self = this;
        var type = e.type;
        if (type == 'drawer-opt') {
            self.$body.toggleClass('drawer-opt');
            self.$body.toggleClass('show-overlay');
        } else {
            if (type == 'menu-opt-in' && showOverlay) {
                self.$body.addClass('show-overlay');
            } else if (type == 'menu-opt-out') {
                self.$body.removeClass('show-overlay');
            }
        }
    },

    initLazyImages: function() {
        window.ORW.lazyload = new LazyLoad({ threshold: 0 });

        const events = {
            'mouseenter .product-image-wrapper' (e) {
                $(e.currentTarget).find('.product-image.alt').removeClass('hide');
            },
        };

        _.extend(this.events, events);
        this.delegateEvents();
    },

    initPromoBanner: function(){
        var self = this;
        var cookieEnabled = self.$promoBanner.data('cookieenabled');
        var cookieDays = self.$promoBanner.data('days');

        if(self.$promoBanner.length > 0){
            if(!ORW.utilities.getCookie('promo_banner')){
                self.$body.addClass('promo-banner-active');
                self.$promoBanner.addClass('activate');
            }
        }

        var events = {
            // 'click .close-promo' : function(e){
            //     self.$promoBanner.slideUp(200);
            //     self.$body.removeClass('promo-banner-active');
            //     self.$promoBanner.removeClass('activate');

            //     if(!ORW.utilities.getCookie('promo_banner') && cookieEnabled ){
            //         ORW.utilities.setCookie('promo_banner','shown', cookieDays);
            //     }
            // }
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    initCookieBanner: function(){
        var self = this;
        if ($('.cookie-banner').length) {
            ORW.cookieBanner = OneCookieBanner.init({
                el: $('.cookie-banner')
            });
        }
    },
    
    initFixedHeader: function() {
        var self = this;
        // Uncomment following code if you need better control on fixed header scrolling, by default the header always fixed by CSS 
        self.$header.scrollToFixed({
            dontSetWidth : true
        });

        // Variables for expanding logo functionality
        var logoExpandTrue = false;
        var $expandingWrapper = self.$body.find('.expanding-logo');
        var $expandingLogo = $expandingWrapper.find('.expanding');
        if ($expandingLogo.length > 0) {
            self.$body.addClass('logo-expanding-active');
            logoExpandTrue = true;
        }
        
        var checkLogoHeight = function() {
            if ($expandingWrapper) {
                var $expandingLogoPosition = $expandingWrapper.position().top;
            }
            return $expandingLogoPosition;
        }

        // Mobile header scroll control
        var lastScrollTop = 0;
        var mobileHeaderHeight = 50;

        var checkScrollDirection = function(){
            var st = $(window).scrollTop();
            if (st > lastScrollTop && st >= mobileHeaderHeight){
                // downscroll code
                if (st - lastScrollTop >= 10) {
                    self.$header.removeClass('scroll-up').addClass('scroll-down');
                }
            } else {
                // upscroll code
                self.$header.removeClass('scroll-down');
                self.$header.addClass('scroll-up');
                if (st < mobileHeaderHeight) {
                    self.$header.removeClass('scroll-up');
                }
            }
            lastScrollTop = st;
        }

        let adjustExpandingLogo = function(){
            let logoStartingPosition = checkLogoHeight(); 
            let scrollTopAmount = lastScrollTop;
            // For logo width
            let percentScrolled = 1 - (window.scrollY / logoStartingPosition);

            if (scrollTopAmount <= logoStartingPosition) {
                $expandingLogo.css('width', `calc(100vw * ${percentScrolled})`);
                self.$header.addClass('expanding-active');
                $expandingWrapper.addClass('logo-visible');
            } else {
                self.$header.removeClass('expanding-active');
                $expandingWrapper.removeClass('logo-visible');
            }
        }

        checkScrollDirection();
        if (logoExpandTrue) {
            ORW.utilities.mediaCheck(function () {
                adjustExpandingLogo();
            }, function () {
                adjustExpandingLogo();
            })
        }
        $(window).on('scroll', function(event){
            checkScrollDirection();
            if (logoExpandTrue) {
                adjustExpandingLogo();
            }
        });
    },
    
    initNavi: function() {
        var self = this;
        
        self.$rawNav = self.$navi.clone();
        
        // Build mobile Nav
        var $slideInMenu = $('<div class="slide-in-menu"></div>');
        var $clonedNavi = self.$navi.clone();
        _.each($clonedNavi.find('.has-dropdown'), function(child){
            var $child = $(child);
            var $dropdown = $child.find('.dropdown');
            // $dropdown.find('.lv2-image').remove();
            if (self.useSlideInMenuForLevel2) {
                $dropdown.appendTo($slideInMenu);
                $child.find('.dropdown').remove();  
            } else {
                $dropdown.appendTo($child);
                $child.find('.dropdown-wrapper').remove();
                $child.find('.nav-link').removeAttr('data-trigger');
                // $child.addClass('expandable');
            }
        });
        
        if (self.useSlideInMenuForLevel2) {
            $slideInMenu.appendTo($clonedNavi);
        }
        self.$mobileNav.find('.header-utilities').before($clonedNavi);
        
        // Build desktop nav
        _.each(self.$navi.find('.children.column-layout'), function(child){
            var currentCol = 0, html = '<li class="back-to">Back</li>';
            var $child = $(child);
            var $level2 = $child.find('.level-2');
            var $level2Images = $child.find('.lv2-image'); 
            
            _.each($level2, function(item,index){
                var $item = $(item);
                var isLast = index == $level2.length-1 ? true : false;
                
                if (currentCol == 0 && currentCol != $item.data('column')) {
                    html += '<li class="divider"><ul>';
                    currentCol = $item.data('column');
                } else if (currentCol != $item.data('column')) {
                    html += '</ul></li><li class="divider"><ul>';
                    currentCol = $item.data('column');
                }
                
                html += $('<div>').append($item.clone()).html();
                
                if (isLast) {
                    html += '</ul></li>';
                }
            });
            
            _.each($level2Images, function(item){
                html += $(item)[0].outerHTML;
            });
            
            $child.html(html);
            var dividers = $child.find('.divider');
            dividers.wrapAll("<li class='nav-links-wrapper'><ul></ul></li>");
            var images = $child.find('.lv2-image');
            images.wrapAll("<li class='nav-images-wrapper'><ul></ul></li>");
        });
    },
    
    initUtilities: function() {
        var self = this;
        var events = {};
        
        // Header hover control (Larger screen)
        self.$header.hoverIntent({
            over: function(){
                if (!self.isMobile()) {
                    self.$body.trigger('menu-opt-in', true); // Change to false to disable overlay on desktop header hover
                }
            },
            out: function(){
                if (!self.isMobile()) {
                    self.$body.trigger('menu-opt-out');
                }
            },
            sensitivity: 100
        });
        
        // Header dropdown hover control (Larger screen)
        self.$header.hoverIntent({
            over: function(){
                if (!self.isMobile()) {
                    $(this).addClass('active');

                    const $lazyElement = $(self.$header).find(".lazy:not(.loaded)");
                    if ($lazyElement.length && window.ORW.lazyload) {
                        window.ORW.lazyload.update();
                    }

                    if (self.miniCartTimer) {
                        // Check if minicart close timer exists, if so kill it.
                        console.log('kill timer');
                        clearTimeout(self.miniCartTimer);
                    }
                }
            },
            out: function(){
                if (!self.isMobile()) {
                    $(this).removeClass('active');
                }
            },
            sensitivity: 100,
            selector: '.has-dropdown:not(.block-search)'
        });
        
        // Copy extra links (if available) to Mobile menu utilities (Small screen)
        var $extraLinkContainer = self.$header.find('.header-extra-links');
        if ($extraLinkContainer.length) {
            $extraLinkContainer = $extraLinkContainer.clone();
            self.$mobileNav.find('.header-utilities').prepend($extraLinkContainer.html());
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    initSearch: function(){
        var self = this;
        if (self.searchInlineMode) {
            self.$header.hoverIntent({
                over: function(){
                    var $target = $(this).find('.block-content');
                    $target.on('transitionend', function(){
                        $target.off('transitionend');
                        setTimeout(function(){ $target.find('input').focus(); },100);
                    });
                    $(this).addClass('active');
                },
                out: function(){
                    $(this).removeClass('active');
                },
                sensitivity: 100,
                selector: '.block-search'
            });
        } else {
            self.searchCtl = OneDrawer.init({
                drawerElem: '#' + self.$searchBar.attr('id'),
                triggerEvent: 'click',
                triggerElem: 'header .search-toggle',
                openCallback: function(){
                    setTimeout(function(){ self.$searchBar.find('input').focus(); },100);
                },
                events: {
                    'click .search-form button' : function(e){
                        e.preventDefault();
                        var $form = $(e.currentTarget).parent('form');
                        if ($form.find('input').val()) {
                            this.closeDrawer();
                            $form.submit();
                        } else {
                            // May be show error message ...
                        }
                    }
                }
            });
        }
    },
    
    initMobileMenu: function(){
        var self = this;
        
        self.mobileMenuCtl = OneDrawer.init({
            drawerElem: '#' + self.$mobileNav.attr('id'),
            triggerEvent: 'click',
            triggerElem: 'header .menu-toggle',
            openCallback: function(e){
                self.$menuToggle.find('.animated-hamburger').addClass('open');
                const $lazyElement = $(self.$mobileNav).find(".lazy:not(.loaded)");
                if ($lazyElement.length && window.ORW.lazyload) {
                    window.ORW.lazyload.update();
                }
            },
            closeCallback: function(e){
                self.$menuToggle.find('.animated-hamburger').removeClass('open');
            }
        });
        
        self.mobileInnerMenuCtl = OneMobileMenu.init({
            el: self.$mobileNav,
            openCallback: function(e){
                self.$mobileNav.addClass('inner-action-engaged');
                self.$menuToggle.find('.animated-hamburger').addClass('inner-action-engaged');
            },
            closeCallback: function(e){
                self.$mobileNav.removeClass('inner-action-engaged');
                self.$menuToggle.find('.animated-hamburger').removeClass('inner-action-engaged');
            }
        });
    },
    
    initMiniCart: function() {
        var self = this;
        var miniCartDrawerInit = function(){
            console.log('init minicart as drawer');
            return OneDrawer.init({
                drawerElem: '#' + self.$miniCart.attr('id'),
                triggerEvent: 'click',
                triggerElem: 'header .block-minicart',
                openCallback: function(){ ajaxCart.load(); }
            });
        };
        var miniCartDropdownOpen = function(){
            self.$body.trigger('menu-opt-in');
            self.$header.find('.block-minicart').addClass('active');
        }
        var miniCartDropdownClose = function(){
            self.$header.find('.block-minicart').removeClass('active');
            self.$body.trigger('menu-opt-out');
        }
        
        self.miniCartCtl = miniCartDrawerInit();
        
        ajaxCart.init({
            formSelector: '.add-to-cart-form',
            addToCartSelector: '.add-to-cart-btn',
            cartContainer: '.minicart-container',
            cartCountSelector: '.minicart-count',
            cartCostSelector: '#CartCost',
            moneyFormat: theme.moneyFormat
        });
        
        if (self.miniCartAsDropdown) {
            // Init minicart as Dropdown on Desktop
            ajaxCart.load();
            
            ORW.utilities.mediaCheck(function () {
                if (self.miniCartCtl) {
                    console.log('minicart drawer destory');
                    self.miniCartCtl.destroy();
                    self.miniCartCtl = false;
                }
            }, function () {
                if (!self.miniCartCtl) {
                    self.miniCartCtl = miniCartDrawerInit();
                }
            })
        }
        
        $(document.body).on('afterAddToCart.ajaxCart', function(evt, cart) {
            if (self.miniCartCtl) {
                if (!self.$miniCart.hasClass('opened')) {
                    self.miniCartCtl.openDrawer();
                    self.miniCartTimer = setTimeout(function(){ self.miniCartCtl.closeDrawer(); }, 3000);
                }
            } else {
                miniCartDropdownOpen();
                self.miniCartTimer = setTimeout(function(){ miniCartDropdownClose(); }, 3000);
            }

            var events = {
                'mouseenter #MiniCart': function(e){
                    if (self.miniCartTimer) {
                        clearTimeout(self.miniCartTimer);
                    }
                },
                'mouseleave #MiniCart': function(e){
                    if (self.miniCartCtl) { 
                        self.miniCartTimer = setTimeout(function(){ self.miniCartCtl.closeDrawer(); }, 1500);
                    } else {
                        self.miniCartTimer = setTimeout(function(){ miniCartDropdownClose(); }, 1500);
                    }
                }
            };

            _.extend(self.events, events);
            self.delegateEvents();
        });
    },

    multisection: function() {
        // Modules used across multiple pages, including: Homepage, PDP, and landing pages
        var self = this;

        var $heroBanner = self.$body.find('.multisection-module-a');
        var $quoteModule = self.$body.find('.multisection-module.quote');
        var $dualSliderModule = self.$body.find('.multisection-module.dual-slider');

        if ($heroBanner.length > 0) {
            var $videos = $heroBanner.find('.video-wrapper');

            OneVideo.init({
                el: $videos,
                isResponsive: false,
                bgVideo: true,
                alwaysVisible: true,
                autoplay: true
            });
        }

        if ($quoteModule.length > 0) {
            var $quoteSlider = $quoteModule.find('.quote-slider.slick');

            if ($quoteSlider) {
                $quoteSlider.slick({
                    dots: false,
                    arrows: false,
                    infinite: true,
                    speed: 600,
                    slidesToShow: 1,
                    rows: 0,
                    fade: true,
                    cssEase: 'ease-in-out',
                    autoplay: true,
                    autoplaySpeed: 5000
                });
            }
        }

        if ($dualSliderModule.length > 0) {
            var $imageSlider = $dualSliderModule.find('.image-slider');
            var $textSlider = $dualSliderModule.find('.text-slider');

            if ($imageSlider.length) {
                $imageSlider.slick({
                    dots: false,
                    arrows: false,
                    infinite: true,
                    rows: 0,
                    speed: 500,
                    focusOnSelect: true,
                    slidesToShow: 1,
                    asNavFor: $textSlider
                });
            }
    
            if ($textSlider.length) {
                $textSlider.slick({
                    dots: true,
                    arrows: false,
                    infinite: true,
                    rows: 0,
                    fade: true,
                    speed: 500,
                    focusOnSelect: true,
                    slidesToShow: 1,
                    asNavFor: $imageSlider
                });
            }
        }
    },
    
    initSubscirbe: function() {
        var self = this;
        if ($('.subscribe-modal').length) {
            ORW.subscribeModal = OneSubscribe.init({
                el: $('.subscribe-modal')
            });
        }
    },
    
    initFooter: function() {
        var self = this;
        var events = {
            'click footer.site-footer .expandable': function(e){
                if (self.isMobile()) {
                    var $curr = $(e.currentTarget);
                    var $activeSiblings = $curr.siblings('.expandable.active');
                    if ($activeSiblings.length) {
                        $activeSiblings.removeClass('active');
                    }
                    $curr.toggleClass('active');
                }
            }
        };
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    },

    devTools: function(){
        var self = this;
        var $indicator = $('#responsive-indicator');
        var $previewBar = $('#preview-bar-iframe');

         // This should only run when a theme is being previewed.
        if(Shopify.PreviewBarInjector !== undefined){
            if($indicator.length > 0 && $previewBar.length > 0 && Shopify.PreviewBarInjector.length == 1){
                $indicator.text("Preview: " + Shopify.theme.name).removeClass("hide");
                var events = {
                    'click #responsive-indicator': function(e){
                        $indicator.toggleClass('active');
                        $previewBar.toggleClass('active');
                    }
                };

                _.extend(self.events, events);
                self.delegateEvents();
            }else{
                $indicator.addClass("hide");
            }
        }
    }
});